package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_10_10_Day_1
import com.veldekar.components.logs.Log_2026_10_10_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-10-10")
@Composable
public fun Log_2026_10_10(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "I’m sorry Tuesday, but Minetrack Raccoon is in another castle.",
        ogTitle = "I’m sorry Tuesday, but Minetrack Raccoon is in another castle.",
        date = LocalDate(2_026, 10, 10),
        aiHint = "Minetrack Raccoon is not the contact's real name, and he's not actually an animal. He's likely a human or dwarf, but the players misheard his name.",
        ogDescription = "The heroes breach the sealed dwarven halls of Ladikor only to learn their contact in The Roving Peers, Midrack Vorkun isn’t there. He’s far to the south… unless he isn’t.",
        ogImage = "images/raccoon.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-43", dateString = "Shimmer 43")
        Log_2026_10_10_Day_1()
        SessionDayHeader(dayId = "shimmer-44", dateString = "Shimmer 44")
        Log_2026_10_10_Day_2()
        SessionMediaItem(
            image = "images/ladikorNewRoute.webp",
            linkImage = "images/ladikorNewRoute.webp",
            width = 2_132,
            height = 2_518,
        )
    }
}
